module.exports = __webpack_public_path__ + "img/CM-SL-CA-Infiniti-Lifestyle.5ddb84d9.jpeg";